import { render, staticRenderFns } from "./bkPolicyList.vue?vue&type=template&id=6dd54280&scoped=true"
import script from "./bkPolicyList.vue?vue&type=script&lang=js"
export * from "./bkPolicyList.vue?vue&type=script&lang=js"
import style0 from "./bkPolicyList.vue?vue&type=style&index=0&id=6dd54280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd54280",
  null
  
)

export default component.exports